var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomersCardIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6459 34.8247C36.4694 34.8247 35.4694 34.4129 34.6459 33.5894C33.8224 32.7659 33.4106 31.7659 33.4106 30.5894C33.4106 29.4129 33.8224 28.4129 34.6459 27.5894C35.4694 26.7659 36.4694 26.3541 37.6459 26.3541C38.8224 26.3541 39.8224 26.7659 40.6459 27.5894C41.4694 28.4129 41.8812 29.4129 41.8812 30.5894C41.8812 31.7659 41.4694 32.7659 40.6459 33.5894C39.8224 34.4129 38.8224 34.8247 37.6459 34.8247ZM29.1753 43.2953V40.6129C29.1753 40.1188 29.293 39.6482 29.5283 39.2011C29.7636 38.7541 30.093 38.4011 30.5165 38.1423C31.5753 37.507 32.6989 37.0306 33.8871 36.7129C35.0753 36.3953 36.3283 36.2364 37.6459 36.2364C38.9636 36.2364 40.2165 36.3953 41.4047 36.7129C42.593 37.0306 43.7165 37.507 44.7753 38.1423C45.1988 38.4011 45.5283 38.7541 45.7636 39.2011C45.9988 39.6482 46.1165 40.1188 46.1165 40.6129V43.2953H29.1753ZM19.293 34.8247V32.0011H30.5871V34.8247H19.293ZM19.293 23.5306V20.707H36.2341V23.5306H19.293ZM30.7283 29.1776H19.293V26.3541H31.9988C31.6694 26.7541 31.4047 27.1894 31.2047 27.66C31.0047 28.1306 30.8459 28.6364 30.7283 29.1776Z",
    fill: "#0F5EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersCardIconActive);
export default __webpack_public_path__ + "static/media/customersCardIconActive.db95bfa00acae444944fb578e1acbe72.svg";
export { ForwardRef as ReactComponent };